import { defineStore } from 'pinia';
import type { Chain } from 'viem/chains';
import { AccountController } from '@reown/appkit';
import { ChainController, ProviderController, ConnectionController } from '@reown/appkit-controllers';

type AccountState = {
  address?: `0x${string}`;
  chainId?: number;
  isConnected: boolean;
};

let listenersBound = false;

export const useWalletStore = defineStore('wallet', {
  state: (): AccountState => ({
    address: undefined,
    chainId: undefined,
    isConnected: false
  }),
  actions: {
    init() {
      if (!listenersBound) {
        // Initial state
        const addr = AccountController.state.address;
        const caip = ChainController.state.activeCaipNetwork;
        this.address = addr as any;
        this.isConnected = !!addr;
        this.chainId = caip?.id as any;

        // Subscribe to address changes
        AccountController.subscribeKey('address', (address) => {
          this.address = address as any;
          this.isConnected = !!address;
        });
        // Subscribe to network changes
        ChainController.subscribeKey('activeCaipNetwork', (net) => {
          this.chainId = net?.id as any;
        });
        listenersBound = true;
      }
    },
    async openModal() {
      // Open AppKit modal via DOM custom element
      const btn = document.createElement('w3m-button');
      btn.style.display = 'none';
      document.body.appendChild(btn);
      (btn as any).open?.();
      setTimeout(() => btn.remove(), 2000);
    },
    async ensureChain(chain: Chain) {
      await ChainController.switchActiveNetwork({ ...chain } as any, { throwOnFailure: false });
    },
    async disconnect() {
      try {
        await ConnectionController.disconnect();
      } finally {
        // Ensure local state reflects disconnection immediately
        this.address = undefined;
        this.chainId = undefined;
        this.isConnected = false;
        try { ProviderController.reset(); } catch {}
      }
    }
  }
});
